export { default as Home } from "./Home/Home";
export { default as Transactions } from "./Transactions/Transactions";
export { default as Profile } from "./Profile/Profile";
export { default as Investments } from "./Investments/Investments";
export { default as Login } from "./Login/Login";
export { default as LoginV2 } from "./Login/LoginV2";
export { default as LoginV3 } from "./Login/LoginV3";
export { default as Password } from "./Login/Password";
export { default as PasswordV2 } from "./Login/PasswordV2";
export { default as PasswordV3 } from "./Login/PasswordV3";
export { default as Bitcoin } from "./Bitcoin/Bitcoin";
export { default as Scheduler } from "./Scheduler/Scheduler";
//new routes
export { default as OverView } from "./NewClient/Accounts/OverView";
export { default as BalanceAndMovements } from "./NewClient/Accounts/BalanceAndMovements";
export { default as InterestAndFees } from "./NewClient/Accounts/InterestAndFees";
export { default as ReportsPanel } from "./NewClient/Accounts/ReportsPanel";
export { default as RequestAppointment } from "./NewClient/Accounts/RequestAppointment";
export { default as SettingsAlertPanel } from "./NewClient/SettingsAlertPanel";
export { default as NewPayment } from "./NewClient/Payments/NewPayment";
export { default as BalanceSheet } from "./NewClient/Payments/BalanceSheet";
export { default as ScheduledPayments } from "./NewClient/Payments/ScheduledPayments";
export { default as MyCalendar } from "./NewClient/Profile/MyCalendar";
export { default as Notifications } from "./NewClient/Profile/Notifications";
export { default as PersonalData } from "./NewClient/Profile/PersonalData";
export { default as PrivacyAndConsent } from "./NewClient/Profile/PrivacyAndConsent";
export { default as Passwords } from "./NewClient/Profile/Passwords";
export { default as GetAQuote } from "./NewClient/Insurance/GetAQuote";
